<template>
    <div>
        <div class="link-toggle filter-toggle" @click="expanded = !expanded" v-bind:class="{ active: expanded }">
            <svg class="i-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g transform="translate(2 2)">
                    <path d="M22.333,14.333a3.008,3.008,0,0,0-2.813,2H14.333v2h5.188a2.993,2.993,0,1,0,2.813-4Zm0,2a1,1,0,1,1-1,1A.985.985,0,0,1,22.333,16.333Zm5,0v2h7v-2Zm0,5a3.008,3.008,0,0,0-2.813,2H14.333v2H24.521a2.993,2.993,0,1,0,2.813-4Zm0,2a1,1,0,1,1-1,1A.985.985,0,0,1,27.333,23.333Zm5,0v2h2v-2Zm-13,5a3.008,3.008,0,0,0-2.813,2H14.333v2h2.188a2.993,2.993,0,1,0,2.813-4Zm0,2a1,1,0,1,1-1,1,.985.985,0,0,1,1-1Zm5,0v2h10v-2Z" transform="translate(-14.333 -14.333)" fill="#747c8f"/>
                </g>
            </svg>
            <svg class="i-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0,24V0H24V24Z" fill="none"/><rect width="21" height="2" transform="translate(5.343 3.929) rotate(45)" fill="#f63"/><rect width="21" height="2" transform="translate(3.929 18.778) rotate(-45)" fill="#f63"/></svg>
            <span>Фильтр расписания</span>
            <span>Закрыть фильтр</span>
        </div>
        <transition-expand>
            <div class="filter" v-if="expanded">
                <div class="filter__header">
                    Фильтр
                </div>
                <div class="filter__container">
                    <div class="filter-title">
                        <span class="filter-title__title">Дата занятия</span>
                        <div class="filter-title__tooltip tooltip">
                            <div class="tooltip__icon">?</div>
                            <div class="tooltip__text">Выберите одну или несколько дат</div>
                        </div>
                    </div>
                    <schedule-filter-calendar/>
                    <div class="filter-title">
                        <span class="filter-title__title">Учебный центр</span>
                    </div>
                    <schedule-filter-address/>
                    <div class="btn btn--contrast ripple ripple--contrast" data-ripple="btn"
                         @click="resetFilter">
                        <span>Сбросить</span>
                    </div>
                </div>
            </div>
        </transition-expand>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex'
    import ScheduleFilterCalendar from "./ScheduleFilterCalendar";
    import ScheduleFilterAddress from "./ScheduleFilterAddress";
    import TransitionExpand from './TransitionExpand.vue';

    export default {
        name: "scheduleFilter",
        components: {ScheduleFilterAddress, ScheduleFilterCalendar, TransitionExpand},
        data() {
            return {
                expanded: true
            }
        },
        computed: {
            ...mapState([
                'urlDate'
            ]),
        },
        watch: {
            'urlDate': {
                handler: function (val) {
                    let searchString = '?';
                    let iterator = 0;
                    for (let key in val) {
                        ++iterator;
                        if (val[key].length) {
                            if (iterator === 1) {
                                searchString = searchString + key + '=' + val[key]
                            } else {
                                searchString = searchString + '&' + key + '=' + val[key]
                            }
                        }
                    }
                    const state = val;
                    const title = 'filterChange';
                    history.pushState(state, title, searchString)
                },
                deep: true,
                immediate: true
            }
        },
        methods: {
            ...mapActions([
                'setFilterAddressModel',
                'setFilterDateModel'
            ]),
            resetFilter() {
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth();
                let day = date.getDate();
                const dateNow = [new Date(year, month, day).getTime()];
                this.setFilterDateModel(dateNow);
                this.setFilterAddressModel([])
            }
        }
    }
</script>

<style lang="scss"
       scoped>
    .expand-enter-active,
    .expand-leave-active {
        transition-property: opacity, height, padding-top, padding-bottom;
    }
    .expand-enter,
    .expand-leave-to {
        opacity: 0;
        padding-top: 0;
        padding-bottom: 0;
    }
</style>
